import { inject, Service } from '@angular/core';
import { BasicHttpClientService } from 'app/shared/services/basic-http-client.service';
import { environment } from 'environments/environment';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { UtilityFunctions } from '../utilities/functions.models';
import { PagedResponse } from '../models/paged-response.model';
import { Showcase, ShowcaseInputModel } from '../models/showcases.model';

@Service()
export class ShowCasesService {
  private readonly baseUrl: string = environment.urls.apiUrl.url;
  private readonly _shopContext = inject(ShopContextStore);
  private readonly _httpClient = inject(BasicHttpClientService);

  getList(params: ShowcaseInputModel, loaderId: string) {
    return this._httpClient.get<PagedResponse<Showcase>>(`${this.baseUrl}/showcases`, { params: UtilityFunctions.prepareParams(params) }, loaderId);
  }

  deleteShowCase(id: number, loaderId: string){
    return this._httpClient.delete(`${this.baseUrl}/showcases/${id}`, {} , loaderId);
  }

  createNewShowCase(sc: Showcase, loaderId: string){
    sc.storeId = this._shopContext.currentShop().id;
    return this._httpClient.post(`${this.baseUrl}/showcases/`, sc , {} , loaderId)
  }

  editShowCase(sc: Showcase, loaderId: string){
    sc.storeId = this._shopContext.currentShop().id;
    return this._httpClient.put(`${this.baseUrl}/showcases/${sc.id}`, sc , {} , loaderId)
  }

  getShowCase(id: number, loaderId: string){
    return this._httpClient.get<Showcase>(`${this.baseUrl}/showcases/${id}`, {} , loaderId);
  }
}
